var lpay = (function (_globalSettings) {
    var animationClass = 'processing-animation';
    return {
        init: function ($container, beforePayAsync, confirm, buttonOnly) {
            var resultEl;
            if (buttonOnly) {
                var _el = $.tmpl('lpay-button-only-' + _globalSettings.Iso.toLowerCase());
                $container.replaceWith(_el);
                resultEl = _el;
                $button = _el;
            } else {
                $container.html($.tmpl('lpay-button-' + _globalSettings.Iso.toLowerCase()));
                resultEl = $container;
                $button = $container.find('@lPaytButton');
            }
            $lpayInfoLink = $container.find('@lpayInfoLink');

            $lpayInfoLink.on('click', function () {
                if (_globalSettings.Iso.toLowerCase() == 'au') {
                    if (document.getElementsByClassName("lpay-modal-wrapper").length == 0) {
                        var t = new XMLHttpRequest;
                        t.onreadystatechange = function() {
                            if (t.readyState === 4 && t.status === 200 && t.responseText != null) {
                                document.body.insertAdjacentHTML("beforeend", t.responseText);
                                document.querySelector(".lpay-modal-wrapper").style.display = "block";
                            }
                        };
                        t.open("GET", "https://images.latitudepayapps.com/modal.html", true);
                        t.send(null);
                    } else {
                        document.querySelector(".lpay-modal-wrapper").style.display = "block";
                    }
                } else {
                    if (document.getElementsByClassName("g-infomodal-container").length == 0) {
                        $.tmpl('genoapay-modal').appendTo('body');
                        $(".g-infomodal-container, .g-infomodal-close").click(function (e) {
                            e.stopPropagation();
                            $(".g-infomodal-container").addClass('hidden-block');
                        });
                        $(".g-infomodal-content").click(function (e) {
                            e.stopPropagation();
                        });
                    } else {
                        $(".g-infomodal-container").removeClass('hidden-block');
                    }
                }
            });

            $button.on('click', function (e) {
                window.app && app.event && app.event.lPayButtonClick();
                
                $('@lPaytButton').addClass(animationClass);

                var deff = beforePayAsync && beforePayAsync();
                deff && deff.done(function () {
                    var isAuth = !(app.cookie.get('us') === null || app.cookie.get('us') === 'unl');

                    var data = {};

                    if (!isAuth && window.app && app.getCustomerData) {
                        data = app.getCustomerData();
                    }

                    if (!isAuth && window.app && app.customerEmailModel) {
                        app.customerEmailModel.getValidatedEmail();
                        data.email = app.customerEmailModel.get('email');
                        data.name = window.__checkoutModel__.get('Delivery').get('Current').get('Name') || '';
                        data.parameters = {};
                        data.parameters.tcAccepted = app.customerEmailModel.getTC();
                        data.parameters.emailsAccepted = app.customerEmailModel.getEmailAccept();
                    }

                    data.redirecturi = location.href;

                    var apiMethod = isAuth ? api.createLPayOrder : api.createPublicLPayOrder;
                    var xhr = _.bind(apiMethod, api)({ data: data});

                    xhr.done(function (result) {
                        if (result.Result) {
                            window.app && app.event && app.event.lPayCreateOrder();
                            var data = result.Value;
                            location.href = data.PaymentUrl;
                        } else {
                            $('@lPaytButton').removeClass(animationClass);
                        }
                    }).fail(function () {
                        $('@lPaytButton').removeClass(animationClass);
                    });
                }).fail(function() {
                    $('@lPaytButton').removeClass(animationClass);
                });
            });
            return resultEl;
        },
        updateAmount: function(amount) {
            $('@lpayInfoLink').attr('src', 'https://images.latitudepayapps.com/snippet.svg?amount=' + amount);

            var text = '10 weekly payments';
            if (amount >= 20 && amount <= 1500) {
                text += ' of ' + window.toMoney(amount / 10, _globalSettings.CurrencySign);
            }
            $('@lpayPriceText').text(text);
        }
    }
})(GlobalSettings);